import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from './Modal/Modal';
import GenericButton from './GenericButton';

const modalStyle = {
  width: '50%',
  height: '250px',
  left: '70%',
};

export default class CreateEditDefinition extends Component {
  constructor(props) {
    super(props);
    const { shared, thisStudy } = props;
    this.state = { shared, thisStudy };
  }

  render() {
    return (
      <div className="small-12 columns">
        <div className="column row">
          <label htmlFor="DefinitionName" className="show-for-sr">
            Name:{' '}
          </label>
          <input
            id="DefinitionName"
            name="DefinitionName"
            type="text"
            defaultValue={this.props.folderName}
            ref={node => (this.editDefinitionName = node)}
            autoFocus
          />
          <input
            id="ThisStudy"
            name="ThisStudy"
            type="checkbox"
            placeholder="Name"
            checked={this.state.thisStudy}
            onChange={() => this.setState({ thisStudy: !this.state.thisStudy })}
          />
          <label htmlFor="ThisStudy">This study only</label>
          <input
            id="Shared"
            name="Shared"
            type="checkbox"
            checked={this.state.shared}
            onChange={() => this.setState({ shared: !this.state.shared })}
          />
          <label htmlFor="Shared">Shared</label>
          <div className="button-group text-right">
            <GenericButton
              name="Ok"
              btnStyle="button"
              onBtnClick={() => {
                if (this.editDefinitionName.value !== '') {
                  this.props.editDefinition({
                    thisStudy: this.state.thisStudy,
                    folderName: this.editDefinitionName.value,
                    shared: this.state.shared,
                    definitionId: this.props.definitionId,
                  });
                  this.props.handleHide();
                } else {
                  this.enterNameModel.show();
                }
              }}
            />
            <GenericButton
              name="Cancel"
              btnStyle="button btn-cncl"
              onBtnClick={() => this.props.handleHide()}
            />
          </div>
        </div>
        <Modal
          title=""
          ref={node => (this.enterNameModel = node)}
          dialogStyles={modalStyle}
        >
          <div className="large-12 columns">
            <div className="column row">
              Please enter a name for new definition.
              <div className="text-right">
                <GenericButton
                  name="Ok"
                  onBtnClick={() => this.enterNameModel.hide()}
                />
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

CreateEditDefinition.propTypes = {
  shared: PropTypes.bool,
  thisStudy: PropTypes.bool,
  definitionId: PropTypes.number,
  folderName: PropTypes.string,
  editDefinition: PropTypes.func,
  handleHide: PropTypes.func,
};
